import { render } from "./PersonalSettings.vue?vue&type=template&id=3feaf374&scoped=true"
import script from "./PersonalSettings.vue?vue&type=script&lang=js"
export * from "./PersonalSettings.vue?vue&type=script&lang=js"

import "./PersonalSettings.vue?vue&type=style&index=0&id=3feaf374&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3feaf374"]])

export default __exports__